export interface Variable<V> {
    variant?: V;
}

export type Size = 'small' | 'medium' | 'large';

export interface Sized {
    size?: Size;
}

export interface Disableable {
    disabled?: boolean;
}

export type InputValue = string | number;

export interface Minifiable {
    small?: boolean;
}

export enum Status {
    Error = 'error',
    Success = 'success',
}

export interface ClassNamed {
    className?: string;
}

export interface Inlined {
    inline?: boolean;
}

export interface Valued {
    value: string | number;
}

export type PartialDeep<T> = {
    [P in keyof T]?: PartialDeep<T[P]>;
};

export interface Settings {
    rootSize: number;
}

export type Subtract<T, K> = Omit<T, keyof K>;

export type MaybeHTMLElement = HTMLElement | undefined;
export type MaybeHTMLElementOrNull = MaybeHTMLElement | null;
export type ElementOrElementGetter = MaybeHTMLElementOrNull | (() => MaybeHTMLElementOrNull);

export type StandartHTMLInputProps = Pick<
    React.InputHTMLAttributes<HTMLInputElement>,
    'className' | 'disabled' | 'name' | 'onBlur' | 'onFocus' | 'readOnly' | 'required'
>;

export interface Activable {
    active?: boolean;
}

export interface DebouncedFunction<T = {}> {
    (args: T): T;
    cancel: () => void;
}

export enum DebounceTimeoutValues {
    textInput = 1000,
}
